"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shift_API_PATH = exports.ShiftPath = void 0;
const shift = "/shift";
exports.ShiftPath = {
    shift,
};
const api_prefix = "api";
const handlePath = ({ path }) => {
    const apiPath = {
        frontend: `${api_prefix}${shift}/${path}`,
        backend: `/${path}`,
    };
    return apiPath;
};
exports.Shift_API_PATH = {
    startShift: handlePath({ path: "start" }),
    endShift: handlePath({ path: "end" }),
    getActiveShift: handlePath({ path: "active" }),
    getTodayShit: handlePath({ path: "today" }),
    getAllTodayShit: handlePath({ path: "all_today" }),
    getShift: (id) => handlePath({ path: id }),
    getActiveShifts: handlePath({ path: "all_active" }),
    getShiftByStaff: (staffId) => handlePath({ path: "active/" + staffId }),
};
//# sourceMappingURL=shift.js.map